<template>
  <d-container fluid class="main-content-container px-4 pb-4">
    <!-- Error -->
    <div class="error">
      <div class="error__content">
        <h2>404</h2>
        <h3>The selected subpage not exists</h3>
        <p>Please try again or contact the system administrator.</p>
        <d-button pill @click="goBack">
          <i class="material-icons">arrow_back</i>
          Go back
        </d-button>
      </div>
    </div>
  </d-container>
</template>

<script>
export default {
  name: 'error-404',
  methods: {
    goBack() {
      window.history.back();
    }
  }
}
</script>
